// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__N9Jbp","title":"Header_title__1wgyC","side":"Header_side__11B-8"};